// extracted by mini-css-extract-plugin
module.exports = {"base":"base--RZ3Di2","back":"back--qkycrK","next":"next--Gji9Ei","outer":"outer--TWfheK","tooltip":"tooltip--Mfkast"};